var map = {
	"./bbc-ukraine.png": 1225,
	"./bbc.svg": 4277,
	"./delfi.png": 5001,
	"./dr.svg": 6856,
	"./fem.svg": 5046,
	"./lrt.svg": 5148,
	"./mail-online.svg": 4021,
	"./politiken.svg": 8649,
	"./polsat.svg": 1706,
	"./postimees.svg": 5855,
	"./the-times.svg": 7638,
	"./tv2.svg": 6398,
	"./tv3.svg": 4831,
	"./tvn.svg": 7482,
	"./tvp.svg": 9356,
	"./woman-magazine.png": 2680,
	"./znaj-ua.svg": 3346
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4451;